export const getModelConsulta = () => ({
    iIdConsulta: 0,
});

export const getFormConsulta = () => ({
    txtFolioConsulta: {
        label: "Folio del paciente:",
        label2: "Correo electrónico:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el folio del paciente",
    },
    txtNombrePaciente: {
        label: "Nombre:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el nombre del paciente",
    },
    txtTelefonoPaciente: {
        label: "Teléfono:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el teléfono del paciente",
    },
    txtCorreoPaciente: {
        label: "Correo electrónico:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un correo electrónico válido del paciente",
    },
    txtFechaProgramadaInicio: {
        label: "Fecha y hora de inicio:",
        required: true,
        value: null,
        error: false,
        message: "Ingrese la fecha de inicio",
    },
    txtFechaProgramadaFin: {
        label: "Fecha y hora de fin:",
        required: true,
        value: null,
        error: false,
        message: "Ingrese la fecha de fin",
    },
    chkFolio: {
        value: false,
        message: "El paciente ya tiene folio o cuenta Meditoc",
    },
    txtTipoBusqueda: {
        label: "Seleccionar el tipo de búsqueda:",
        required: true,
        value: "1",
    },
    slcIdioma: {
        label: "Seleccionar el Idioma:",
        required: true,
        value: "es",
        error: false,
        message: "Seleccione la opción deseada",
    },
});

export const getFormFiltroConsulta = () => ({
    txtFechaDe: {
        label: "Fecha de:",
        value: new Date(),
    },
    txtFechaA: {
        label: "Fecha a:",
        value: new Date(),
    },
});

export const getAdminConsultaColumns = () => [
    { title: "", field: "sIconStatus", hideSort: true, hideFilter: true },
    { title: "Inicio", field: "sFechaProgramadaInicio" },
    { title: "Fin", field: "sFechaProgramadaFin" },
    { title: "Paciente", field: "sNombrePaciente" },
    { title: "Usuario", field: "sFolio" },
    { title: "Estatus", field: "sEstatusConsulta" },
    { title: "Creado", field: "sFechaCreacion" },
];
